<template>
  <div class="relative ml-8">
    <button
      v-if="hasChildren"
      class="text-[text-[#68737D] absolute -left-6 top-4 rounded-full border border-slate-300 px-1 text-xs outline-none"
      @click="$emit('toggleChildren', asset.id)"
    >
      <span v-if="!asset.expandChildren">&plus;</span>
      <span v-else>&minus;</span>
    </button>
    <button
      :id="`asset-${uid}`"
      :key="asset.id"
      type="button"
      class="flex w-[280px] items-center justify-between rounded border-l-4 border-main-primary bg-white p-3 shadow outline-none transition-all"
      :class="{
        'border-y-2 border-r-2': asset.selected,
        'opacity-40': asset.hide,
      }"
      @click="$emit('toggleSelection', asset.id)"
    >
      <div class="flex w-[120px] items-center gap-x-1 text-[#1D354AC9]">
        <BuildingIcon custom-style="size-4" />
        <span
          :title="asset.asset_name"
          class="truncate text-base capitalize"
        >{{
          asset.asset_name
        }}</span>
      </div>
      <span
        class="rounded bg-main-primary/10 px-1 py-0.5 text-xs text-main-primary"
      >{{
        themeIsGhg ? asset.categories.length : asset.metrics.length
      }}
        Metrics Assigned</span>
    </button>
    <!-- Children -->
    <Transition
      enter-class="opacity-0"
      enter-active-class="transition-all duration-300"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="transition-all duration-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="canViewChildren"
        class="ml-12 mt-4 flex flex-col gap-y-2"
      >
        <EsgAssignAssetTreeNode
          v-for="child in asset.children"
          :key="child.id"
          :node="child"
          @toggle-selection="$emit('toggleSelection', $event)"
          @toggle-children="$emit('toggleChildren', $event)"
        />
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: 'EsgAssignAssetTreeNode',

  inject: ['themeIsGhg'],

  props: {
    node: {
      type: Object,
      required: true,
    },
  },

  emits: ['toggleSelection', 'toggleChildren'],

  data() {
    return {
      uid: null,
      asset: this.node,
    }
  },

  computed: {
    canViewChildren() {
      return this.hasChildren && this.asset.expandChildren
    },
    hasChildren() {
      return this.asset.children.length
    },
  },

  watch: {
    node(newNode) {
      this.asset = newNode
    },
  },

  mounted() {
    this.uid = this.$.uid
  },
}
</script>
